import { cn } from '@/lib/utils';
import { formatPreciseAgo } from '@/lib/relativeTime';

/**
 * The "Updated <relative>" line under a unit's current-location block. Shows
 * when the unit's position was last fixed — units.location_updated_at (T-021),
 * a real all-source LOCATION-fix time, NOT the comms-liveness clock.
 *
 * Renders nothing when there is no fix time yet (location_updated_at is null
 * until a writer first stamps it), so a unit with a position but no recorded fix
 * time shows no fake/stale timestamp — and callers can drop it in
 * unconditionally. Neutral tokens, on-theme, matching LocationSourceBadge.
 */
export function LocationFixTime({
  at,
  now,
  className,
}: {
  at?: string | null;
  now?: Date;
  className?: string;
}) {
  if (!at) return null;
  return (
    <div
      className={cn('text-xs text-muted-foreground mt-1', className)}
      title={new Date(at).toLocaleString()}
    >
      Updated {formatPreciseAgo(at, now)}
    </div>
  );
}
